export default {
  workListsIds: [],
  currentWorkList: null
};
